export default "__VITE_ASSET__8740b9fc__"